"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssistChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AssistChip = require("./AssistChip.styles");
var _ChipLabel = require("./ChipLabel");
var _ChipSpinner = require("./ChipSpinner");
var _excluded = ["avatar", "buttonType", "children", "chipElevation", "disabled", "icon", "iconPosition", "iconSize", "inverse", "fluid", "loading", "loadingVoiceOver", "size"];
/**
 * Assist chips are used to trigger actions related to pieces of content.
 * Avoid using them as CTAs or for navigation (ex: as tabs).
 *
 * @extends Button
 * @related ['FilterChip', 'InputChip', 'Tag']
 * @since 8.97.0
 */
var AssistChip = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var avatar = props.avatar,
    buttonType = props.buttonType,
    children = props.children,
    chipElevation = props.chipElevation,
    disabled = props.disabled,
    icon = props.icon,
    iconPosition = props.iconPosition,
    iconSize = props.iconSize,
    inverse = props.inverse,
    fluid = props.fluid,
    loading = props.loading,
    loadingVoiceOver = props.loadingVoiceOver,
    size = props.size,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var adjustedAvatar;
  if (avatar) {
    // Prevent img alt text from being read and
    // chip from being announced as a "button, group"
    adjustedAvatar = /*#__PURE__*/(0, _react.cloneElement)(avatar, {
      'aria-hidden': 'true',
      'as': 'span'
    });
  }
  return /*#__PURE__*/_react.default.createElement(_AssistChip.StyledAssistChip, (0, _extends2.default)({
    buttonType: "tertiary",
    chipElevation: chipElevation,
    disabled: disabled,
    fluid: false,
    icon: icon,
    iconPosition: "start",
    iconSize: "xs",
    inverse: false,
    loading: loading,
    ref: forwardedRef,
    type: "button"
  }, rest), loading ? /*#__PURE__*/_react.default.createElement(_ChipSpinner.ChipSpinner, {
    loadingVoiceOver: loadingVoiceOver
  }) : null, avatar ? adjustedAvatar : null, /*#__PURE__*/_react.default.createElement(_ChipLabel.ChipLabel, null, children));
});
exports.AssistChip = AssistChip;
AssistChip.displayName = 'AssistChip';
AssistChip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Adds a leading avatar. Takes an `Avatar` component. Ignores the `Avatar`’s `size` prop
   * (i.e. the avatar size is fixed).
   */
  avatar: _propTypes.default.node,
  /**
   * The assist chip’s text label. To add decorators, use the `icon` and `avatar` props.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * When true, adds a drop shadow. Useful for making the assist chip easier to see on
   * certain backgrounds (ex: on top of a photo or map)
   */
  chipElevation: _propTypes.default.bool,
  /**
   * Sets the assist chip as disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * Adds a leading icon. Takes an `Icon` component but ignores its `size` prop
   * (i.e. the icon size is fixed). Does not support `DetailedIcon`.
   */
  icon: _propTypes.default.node,
  /**
   * When true, displays the chip in its loading state. This adds a spinner next to the
   * label text and disables pointer events. The chip is not fully disabled so it can still
   * retain focus.
   */
  loading: _propTypes.default.bool,
  /**
   * The text that will be announced to screen readers when the chip changes to
   * its loading state. Defaults to "loading". Text is `VisuallyHidden`.
   *
   * Don't include the chip's label text in `loadingVoiceOver` because some assistive
   * technologies will, by default, read the label text after the `loadingVoiceOver` text.
   */
  loadingVoiceOver: _propTypes.default.string
} : {};
AssistChip.defaultProps = {
  avatar: null,
  chipElevation: false,
  disabled: false,
  icon: null,
  loading: false,
  loadingVoiceOver: 'Loading'
};